'use strict';

bbw.model.ForumPost = bbw.model.AbstractPostManager.extend({

    include: bbw.model.ForumAreasTrait,

    _getPostTypeName: function() {
        return 'forum';
    },

    _doInit: function() {
        return this.$q.all([
            this._doLoadPost(),
            this.loadForumAreas()
        ]);
    }

});
